import { AppState } from 'common/models/AppState';
import { getFormsTranslator } from 'common/services/i18n';
import { selectFormTransaction } from '../selectors';
import { FormValidationResult, validateEntireForm } from './formStepRegistry';
import { isFinalValidationEnabled, shouldExemptTransaction } from './policy';

export function getFormSubmissionValidation(state: AppState): FormValidationResult {
  if (!isFinalValidationEnabled()) {
    return { isValid: true, failures: [] };
  }

  const transaction = selectFormTransaction(state);
  if (shouldExemptTransaction(transaction)) {
    return { isValid: true, failures: [] };
  }

  return validateEntireForm(state, getFormsTranslator());
}

export function assertFormValidForSubmission(state: AppState): boolean {
  return getFormSubmissionValidation(state).isValid;
}
